import { useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useFormContext } from "react-hook-form"
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import CompanyName from 'components/RCPro/components/form/CompanyName/CompanyName'
import CompanySiret from 'components/RCPro/components/form/CompanySiret/CompanySiret'
import CompanyAddress from 'components/RCPro/components/form/CompanyAddress/CompanyAddress'
import CompanyCity from 'components/RCPro/components/form/CompanyCity/CompanyCity'
import CompanyZipCode from 'components/RCPro/components/form/CompanyZipCode/CompanyZipCode'
import InputError from 'components/common/InputError/InputError'
import Loader from 'components/assets/icons/Loader'
import ArrowAlt from 'components/assets/icons/ArrowAlt'
import api from 'helpers/api'
import InputStyle from 'components/common/Input/Input.module.scss'
import style from './SelectCompany.module.scss'

const SelectCompany = ({ onChange, value }) => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const [companiesMatchs, setCompaniesMatchs] = useState([])
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState(false)
  const [ searchEngine, toggleSearchEngine ] = useState(true)
  const { register, errors } = useFormContext()

  useEffect(() => {
    if (!searchEngine || value !== text){
      setText(value?.toLowerCase())
      return
    }
    setLoading(true)
    if (text?.length < 3){
      setList(false)
    }
    const timer = setTimeout(async () => {
      if (!text?.length || !searchEngine) return
      setList(true)

      try{
        const {sentence, companies} = await api.get({
          url: `/RCPro/companies/${text}`,
          headers: { Authorization: `Bearer ${state.token}` }
        })
  
        if (sentence === text) {
          setCompaniesMatchs(companies)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    }, text.length < 3 ? 5000 : 500)

    return () => clearTimeout(timer);
  }, [state, text, searchEngine, value]);

  const selectCompany = (company) => {
    const values = Object.values(company)
    if (values.length < 5 || values.includes(undefined)){
      toggleSearchEngine(false)
    }
    onChange(company)
    setList(false)
  }

  return searchEngine
    ? <>
      <div className={classNames(InputStyle['input-wrapper'], style.addressContainer, errors?.company && InputStyle.error)}>
        <label className={classNames('input-label')} htmlFor='select'>
          {t('mainReporting:form.company.label')}
        </label>

        <input
          id='select'
          type='text'
          placeholder={t('mainReporting:form.company.placeholder')}
          {...register('organizationName', { required: t('mainReporting:form.mandatory') })}
          onChange={(e) => {
            const organizationName = e.target.value
              .replace(/^ /, '')
              .replace(/  +/g, ' ')
            setText(organizationName)
            onChange({ organizationName })
          }}
        />

        {list &&
          <ul>
            {loading
            ?
            <li className={style.loading}>
              <Loader />
            </li>
            :
            <li>
              <ul>
                {companiesMatchs.map((opt, id) => {
                  const headquarterZipcode = opt.zipCode
                    ? ('0'+opt.zipCode).slice(-5)
                    : ''

                  const headquarterAddress = (
                    (opt.streetNumber ? opt.streetNumber+' ' : '')+
                    (opt.streetType ? opt.streetType+' ' : '')+
                    (opt.streetName ? opt.streetName : '')
                  )

                  return (
                    <li key={`option-${id}`} className={style.item} onClick={() => selectCompany({
                      organizationName: opt.companyName || opt.firstname+' '+opt.lastname,
                      companyImmatriculation: opt.siret,
                      headquarterAddress,
                      headquarterCity: opt.city,
                      headquarterZipcode
                    })}>
                      <span className={style.siret}>
                        {opt.siret}
                      </span>
                      {opt.companyName
                        ? opt.companyName 
                        : opt.firstname || opt.lastname
                          ? (opt.firstname+' '+opt.lastname)
                          : 'Unknown'
                      }
                      <span className={style.address}>
                        {headquarterAddress + ', ' + (headquarterZipcode ? headquarterZipcode+' ' : '') + opt.city}
                      </span>
                    </li>
                  )
                })}
              </ul>
            </li>
            }
            <li className={style.item} onClick={() => toggleSearchEngine(false)}>
              {t('mainReporting:form.company.errors.notfound')}
            </li>
          </ul>
        }
      </div>

      <InputError error={errors?.company} />
    </>
    : <>
    <span className={style.search} onClick={() => toggleSearchEngine(true)}>
        <ArrowAlt /> Rechercher mon entreprise
      </span>
      <CompanyName
        register={register}
        error={errors?.organizationName}
      />
      
      <CompanySiret
        register={register}
        error={errors?.companyImmatriculation}
      />

      <CompanyAddress
        register={register}
        error={errors?.headquarterAddress}
      />

      <CompanyZipCode
        register={register}
        error={errors?.headquarterZipcode}
      />

      <CompanyCity
        register={register}
        error={errors?.headquarterCity}
      />
    </>
}

export default SelectCompany
